<template>
  <div class="game-floor">
    <van-popup
      class="game-pop"
      v-model="showGamePop"
      position="bottom"
      @click-overlay="clickClose"
      :style="{ height: '70%' }"
    >
      <div class="pop-head">
        <div class="title">请选择游戏区</div>
        <div class="close-icon">
          <img src="@/assets/img/close.png" @click="clickClose" />
        </div>
      </div>
      <div class="game-list-container">
        <van-cell-group>
          <template  v-for="(item, idx) in dataList">
            <van-cell :key="idx" :value="item" @click="selGameItem(item)" />
          </template>
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'GameFloor',
  props: ['dataList', 'showGamePop'],
  created () {
  },
  methods: {
    selGameItem(item) {
      this.$emit('selectItem', item)
    },
    clickClose () {
      this.$emit('closeGamePop')
    }
  }
}
</script>

<style lang="scss" scoped>
  .game-floor{
    .game-pop{
      box-sizing: border-box;
      border-radius: 6px 6px 0 0;
      overflow-y: inherit;
      .pop-head{
        position: absolute;
        width: 100%;
        height: .4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FAFAFA;
        padding: 0 10px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-sizing: border-box;
        .close-icon {
            position: absolute;
            right: .16rem;
            img {
                width: .15rem;
            }
        }
      }
      .game-list-container{
        padding: 0 16px 20px;
        margin-top: .4rem;
        overflow-y: auto;
        height: 4.39rem;
        box-sizing: border-box;
        padding-bottom: .65rem;
      }
    }
  }
</style>
